"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeTxMessages = exports.defaultTxFee = exports.fundsToCoins = void 0;
var proto_1 = require("../../proto");
var endpoints_1 = require("../endpoints");
/**
 * Converts a fund map to a concatenated string representation ("<value><denomination>")
 * @param funds
 */
var fundsToCoins = function (funds) {
    if (!funds) {
        return '';
    }
    var result = [];
    funds.forEach(function (value, denomination) {
        result.push("".concat(value).concat(denomination));
    });
    return result.join(',');
};
exports.fundsToCoins = fundsToCoins;
/**
 * This is constant for now,
 * but should be fetched as an estimation
 * from the Tendermint node once this functionality
 * is available.
 *
 * Each package call / deployment
 * costs a fixed 1 GNOT
 * https://github.com/gnolang/gno/issues/649
 */
exports.defaultTxFee = '1000000ugnot'; // 1 GNOT
/**
 * Decodes (and unrolls) Transaction messages into full objects
 * @param {Any[]} messages the encoded transaction messages
 */
var decodeTxMessages = function (messages) {
    return messages.map(function (m) {
        switch (m.typeUrl) {
            case endpoints_1.MsgEndpoint.MSG_CALL:
                return __assign({ '@type': m.typeUrl }, proto_1.MsgCall.decode(m.value));
            case endpoints_1.MsgEndpoint.MSG_SEND:
                return __assign({ '@type': m.typeUrl }, proto_1.MsgSend.decode(m.value));
            case endpoints_1.MsgEndpoint.MSG_ADD_PKG:
                return __assign({ '@type': m.typeUrl }, proto_1.MsgAddPackage.decode(m.value));
            default:
                throw new Error("unsupported message type ".concat(m.typeUrl));
        }
    });
};
exports.decodeTxMessages = decodeTxMessages;
